var locale = {
  placeholder: 'Seleccionar hora'
};
export default locale;